import { observer } from "mobx-react-lite";
import { Fragment } from "react";
import { DownloadOutlined } from "@ant-design/icons";
import {
  Button,
  Checkbox,
  ConfigProvider,
  Empty,
  Form,
  Input,
  Modal,
  Select,
  Space,
  Table,
} from "antd";
import { ANumberManageStore } from "../../../../store";
const { Column } = Table;
const CheckboxGroup = Checkbox.Group;

function TemplatePreview(props: any) {
  const form = Form.useFormInstance();
  const { Option } = Select;

  const getFormData = (
    changeValue: powerSearchData,
    allValues: powerSearchData
  ) => {
    ANumberManageStore.setSearchModalForm({ ...allValues });
  };

  const searchBtn = () => {
    ANumberManageStore.resetPage();
    ANumberManageStore.previewPage();
  };

  const resetSearchbth = () => {
    ANumberManageStore.setSearchModalForm({});
    searchBtn();
  };

  const submitPower = () => {
    if (ANumberManageStore.templateModal.update) {
      ANumberManageStore.batchEditAPoolNumber();
    } else if (ANumberManageStore.templateModal.add) {
      ANumberManageStore.batchAddAPoolNumber();
    } else if (ANumberManageStore.templateModal.delete) {
      ANumberManageStore.batchDeleteAPoolNumber();
    }
    ANumberManageStore.templateModal.close();
  };

  const tableEmptyRender = () => {
    return (
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={<>暂无数据</>}
      ></Empty>
    );
  };
  return (
    <Fragment>
      <Modal
        width={"80%"}
        centered
        title={ANumberManageStore.templateModal.title}
        open={ANumberManageStore.templateModal.isOpen}
        destroyOnClose={true}
        loading={ANumberManageStore.previewLoading}
        onCancel={() => ANumberManageStore.templateModal.close()}
        footer={[
          <Button
            key="back"
            onClick={() => ANumberManageStore.templateModal.close()}
          >
            取消
          </Button>,
          <Button
            disabled={ANumberManageStore.allowSubmit}
            key="submit"
            type="primary"
            onClick={submitPower}
          >
            提交
          </Button>,
        ]}
      >
        <Form
          form={form}
          initialValues={ANumberManageStore.searchFormModal}
          autoComplete="off"
          layout="inline"
          style={{ marginTop: "20px" }}
          className="formSty"
          onValuesChange={getFormData}
        >
          <Form.Item
            label="号码"
            name="phoneNumber"
            style={{ width: "266px", marginBottom: "10px" }}
          >
            <Input placeholder="请输入号码" />
          </Form.Item>
          <Form.Item
            label="校验状态"
            name="verifyResult"
            style={{ width: "266px", marginBottom: "10px" }}
          >
            <Select placeholder="请选择">
              <Option value={true}>是</Option>
              <Option value={false}>否</Option>
            </Select>
          </Form.Item>
          <Form.Item
            label="错误类型"
            name="errorType"
            style={{ width: "266px", marginBottom: "10px" }}
          >
            <Select placeholder="请选择">
              {ANumberManageStore.templateModal.add && (
                <Option value={"池内重复"}>池内重复</Option>
              )}
              <Option value={"表内重复"}>表内重复</Option>
              <Option value={"其他错误"}>其他错误</Option>
              {!ANumberManageStore.templateModal.add && (
                <Option value={"号码不存在"}>号码不存在</Option>
              )}
            </Select>
          </Form.Item>
          <Form.Item>
            <Space>
              <Button type="primary" onClick={searchBtn}>
                搜索
              </Button>
              <Button htmlType="reset" onClick={resetSearchbth}>
                重置
              </Button>
              {ANumberManageStore.exportErrorFlag && (
                <Button onClick={() => ANumberManageStore.exportError()}>
                  <DownloadOutlined />
                  导出
                </Button>
              )}
            </Space>
          </Form.Item>
        </Form>
        {/* {ANumberManageStore.exportErrorFlag&&<DownloadOutlined className="outLineIcon" onClick={()=>ANumberManageStore.exportError()}/>} */}
        <ConfigProvider renderEmpty={tableEmptyRender}>
          <Table
            dataSource={ANumberManageStore.tableDataModal.records}
            rowKey={(record: any) => record.id}
            loading={ANumberManageStore.previewTableLoad}
            scroll={{ x: 1300, y: "calc(100vh - 400px)" }}
            size="small"
            style={{marginTop:'10px'}}
            pagination={{
              current: ANumberManageStore.pageDataModal.page,
              pageSize: ANumberManageStore.pageDataModal.size,
              onChange: ANumberManageStore.pageDataModal.changePage,
              pageSizeOptions: [10, 15, 20, 25],
              showSizeChanger: true,
              total: ANumberManageStore.tableDataModal.total,
              showTotal: () =>
                `共计${ANumberManageStore.tableDataModal.total}条`,
              position: ["bottomLeft"],
            }}
          >
            <Column
              ellipsis={true}
              width={120}
              title="号码"
              dataIndex="phoneNumber"
            />
            <Column
              width={150}
              ellipsis={true}
              title="所属A编号"
              dataIndex="callInitializerNumberPoolNo"
            />
            {!ANumberManageStore.templateModal.delete && (
              <Column
                title="号码状态"
                width={100}
                dataIndex="status"
                render={(status) => {
                  if (status === "1") {
                    return "待上架";
                  } else if (status === "2") {
                    return "已上架";
                  } else if (status === "3") {
                    return "已禁用";
                  }
                }}
              />
            )}
            {ANumberManageStore.templateModal.add && (
              <Column
                title="号码类型"
                width={100}
                dataIndex="numberType"
                render={(numberType) => {
                  if (numberType === "0") {
                    return "移动电话";
                  } else if (numberType === "1") {
                    return "固定电话";
                  }
                }}
              />
            )}
            {!ANumberManageStore.templateModal.delete && (
              <Column
                title="基础运营商"
                width={100}
                dataIndex="carrier"
                render={(carrier) => carrier}
              />
            )}
            {!ANumberManageStore.templateModal.delete && (
              <Column width={120} title="备注" dataIndex="remark" />
            )}
            <Column
              title="校验状态"
              width={100}
              dataIndex="verifyResult"
              render={(status) => (status ? "是" : "否")}
            />
            <Column width={120} title="错误类型" dataIndex="errorType" />
            <Column width={200} title="错误原因" dataIndex="errorMsg" />
          </Table>
        </ConfigProvider>
        <CheckboxGroup
          value={ANumberManageStore.checkedList}
          onChange={(list) => ANumberManageStore.changeCheckList(list)}
        >
          {ANumberManageStore.templateModal.add && (
            <Checkbox value={"poolRepeat"}>
              忽略池内重复（{ANumberManageStore.previewCountData.poolRepeat}）
            </Checkbox>
          )}
          {
            <Checkbox value={"tableRepeat"}>
              忽略表内重复（{ANumberManageStore.previewCountData.tableRepeat}）
            </Checkbox>
          }
          {!ANumberManageStore.templateModal.add && (
            <Checkbox value={"numberNotExist"}>
              忽略号码不存在错误（
              {ANumberManageStore.previewCountData.numberNotExist}）
            </Checkbox>
          )}
          {
            <Checkbox value={"otherError"}>
              忽略其他错误（{ANumberManageStore.previewCountData.otherError}）
            </Checkbox>
          }
        </CheckboxGroup>
      </Modal>
    </Fragment>
  );
}

export default observer(TemplatePreview);
